import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import VideoControl from '../VideoControl'

export type VideoControlsMidProps = {
    buttonType: 'play-active' | 'pause-active' | 'reload'
    onPlayerStateChange: () => void
}

const VideoControlsMid: FunctionComponent<VideoControlsMidProps> = ({
    buttonType,
    onPlayerStateChange,
}): ReactElement => {
    return (
        <Grid center horizontal noExpand>
            <VideoControl
                name={buttonType}
                color="WHITE"
                fontSize={40}
                onPress={onPlayerStateChange}
            />
        </Grid>
    )
}

export default memo(VideoControlsMid)
